<template>
  <footer
    v-if=" $route.name !== 'Index' "
    v-show="showFooter"
  >
    <div class="page-footer">
      <div class="logo" />
      <div
        v-if="options && footer && footer.description"
        v-html="footer.description"
      />

      <div
        v-for="(info, indexInfo) in footer.information"
        :key="indexInfo"
        :class="info.section_class"
      >
        <Flex
          v-if="options && footer && footer.information"

          justify="center"
          class="footer__ctas--ciao"
        >
          <div
            v-for="(item, index) in info.section"
            :key="index"
            class="footer__item"
          >
            <Flex>
              <Label
                v-if="item.label"
                :data="{
                  value: item.label
                }"
              />
              <Richtext
                v-if="item.content"
                :data="{
                  value: item.content
                }"
              />
              <Cta
                v-if="item.cta"
                :data="item.cta"
                theme="footer"
              />
            </Flex>
          </div>
        </Flex>
      </div>
    </div>
    <div class="footer__brown">
      <a :href="footer.brown_link">
        <div
          v-if="options && footer && footer.description_brown"
          class="footer__brown--description"
          v-html="footer.description_brown"
        />
        <div
          v-for="(item, index) in footer.loghi_brown"
          :key="index"
        >
          <img
            :src="item.logo.url"
            alt=""
            class="footer__brown--logo"
          >
        </div>
      </a>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

import Label from '@/components/typo/label';
import Richtext from '@/components/typo/richtext';
import Cta from '@/components/typo/cta';

export default {
  name: 'Footer',
  components: {
    Label,
    Richtext,
    Cta,
  },
  computed: {
    ...mapGetters(['options', 'currentPost']),
    showFooter() {
      if (this.$route.meta.hideFooter) {
        return false;
      }
      if (!this.$route.meta.customView && !this.currentPost) {
        return false;
      }
      return true;
    },
    footer() {
      const { footer } = this.options;
      return footer;
    },
  },
};
</script>

<style lang="scss" scoped>

.page-footer {
  background: var(--orange);
  min-height: 200px;
  color: var(--brown);
  text-align: center;
  margin-top: 120px;

  padding: 60px 75px;
  @extend %typo--m;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer__item {
  margin: 0 15px;
  width: 150px;
  .cta {
    width: 100%;
  }
}

.footer__ctas {
  margin-top: 50px;
}
.footer__ctas--ciao {
  flex-wrap: wrap;
  @include mq(s){
    flex-wrap: nowrap;
  }
  .footer__item {
    margin-bottom: 20px;
  }
}

.logo {
  width:  60px;
  height: 60px;
  background: url('~@/assets/svg/logo_gua-brown.svg');
  background-size: 100%;
  margin-bottom: 50px;
}

.footer__brown {
  background-color: var(--brown);
  padding: 60px 75px;

  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;

  &--description {
    max-width: 840px;
    margin-bottom: 50px;
  }
  &--logo {
    width: 540px;
  }
}

</style>
